import axios from "axios";
import { CREATE_COMPANY } from "@/utils/constants/constants.js";
import { validate_non_empty_string, validate_non_sub_zero_number } from "@/utils/validations/validate_inputs";

function parse_response_data(response_data) {
  return typeof response_data === "string" ? JSON.parse(response_data) : response_data;
}

export default {
  methods: {
    create_company() {
      if (!validate_non_empty_string(this.company_name)) {
        this.show_error("Programme name must not be empty");
        return Promise.resolve();
      }
      if (!validate_non_empty_string(this.company_description)) {
        this.show_error("Programme description must not be empty");
        return Promise.resolve();
      }
      if (!validate_non_sub_zero_number(this.selected_company_type)) {
        this.show_error("Please select a valid programme type");
        return Promise.resolve();
      }

      const payload = {
        project_name: this.company_name,
        project_description: this.company_description,
        project_type_id: this.selected_company_type,
      };
      return this.show_loader("Creating programme...").then((loader) => axios.post(
        CREATE_COMPANY, payload, { headers: this.headers }
      ).then(async (response) => {
        const target_project_id = parse_response_data(response.data)?.data?.project_id;
        if (this.import_source_project_id && target_project_id) {
          await this.import_project_configuration(target_project_id);
        }
        this.close_modal("create_company");
        this.company_name = "";
        this.company_description = "";
        this.selected_company_type = "";
        await this.get_companies(false);
        await this.get_deactivated_projects();
        this.show_success("Programme created successfully");
      }).catch((error) => {
        this.show_error(`Error creating programme: ${error.response.data.message}`);
      }).finally(() => {
        if (loader) this.close_loader(loader);
      }));
    },
  },
};
